module.exports = {"id":"18115","name":"Rúben Fernandes","rating":"73","photo":"./data/images/photos/1/18115.png","club":{"name":"Portimão","logo":"./data/images/clubs/Portimao.png"},"positions":["DC","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenFernandes0.json
// module id = 3732
// module chunks = 0